import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor,HttpEvent } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class httpIntercepService implements HttpInterceptor {

    constructor() {

    }

    intercept(req: import("@angular/common/http").HttpRequest<any>, next: import("@angular/common/http").HttpHandler): Observable<HttpEvent<any>> {
       
       const cloneResquest=req.clone({
          // headers:req.headers.set('Content-type','application/json')
       });
       //console.log(cloneResquest);
       
       return next.handle(cloneResquest)
    }
    



}